export const List = () => import("./List.vue");
export const Details = () => import("./Details.vue");
export const CheckNoteSheet = () => import("./CheckNoteSheet.vue");
